import { configureStore } from "@reduxjs/toolkit";

import UserReducer from "./data/user/reducerUser";

export const store = configureStore({
  reducer: {
    userReducer: UserReducer,
  },
});

export default store;
